<template>
    <BModal
        v-model="modalShow"
        size="xl"
        :no-close-on-backdrop="true"
        :no-footer="true"
        body-class="p-0"
    >
        <template #header>
            <div class="d-flex align-items-center w-100">
                <h5 class="m-0 flex-grow-1">
                    Редагування заявки № {{ position?.application_id || '—' }}
                    <small class="text-muted"
                           v-if="position?.tender_id">до тендера № {{ position.tender_id }}</small>
                </h5>
                <BButton size="sm" variant="link" class="text-muted" @click="close">
                    <i class="fal fa-times"></i>
                </BButton>
            </div>
        </template>
        
        <BOverlay :show="is_load" rounded="sm" opacity="0.15">
            <div class="p-3">
                
                <div class="card shadow-sm mb-3">
                    <div class="card-header py-2 d-flex justify-content-between align-items-center">
                        <div class="fw-600">
                            {{ position?.title || '—' }}
                            <span class="text-muted ms-2" v-if="position?.catalog_number">({{ position.catalog_number }})</span>
                        </div>
                        <span class="badge bg-light text-dark" v-if="position?.company">
                            {{ position.company }} — {{ position.contact_name }}
                        </span>
                    </div>
                    
                    <div class="card-body">
                        <div class="row g-3">
                            <div class="col-md-4">
                                <div class="small text-muted">Валюта</div>
                                <div class="fs-6 fw-600 text-uppercase">{{ currencyLabel }}</div>
                            </div>
                            
                            <div class="col-md-4" v-if="showRate">
                                <div class="small text-muted">Курс</div>
                                <div class="fs-6 fw-600">{{ rate }}</div>
                            </div>
                            
                            <div class="col-md-4">
                                <div class="small text-muted">Кількість у заявці</div>
                                <div class="fs-6 fw-600">{{ qty }}</div>
                            </div>
                            
                            <div class="col-md-4">
                                <div class="small text-muted">Поточна ціна</div>
                                <div class="fs-6 fw-600">
                                    {{ money(position?.price) }} {{ currencySymbol }}
                                </div>
                            </div>
                            
                            <div class="col-md-4">
                                <div class="small text-muted">Поточна сума</div>
                                <div class="fs-6 fw-600">
                                    {{ money(position?.summ) }} {{ currencySymbol }}
                                </div>
                            </div>
                            
                        </div>
                    </div>
                </div>
                
                <div class="card shadow-sm">
                    <div class="card-body">
                        <div class="row g-3 align-items-end">
                            <div class="col-md-6">
                                <label class="form-label">Нова ціна (за од.)</label>
                                <BFormInput v-model="priceInput" :state="priceState"
                                            :placeholder="`Напр., ${placeholderPrice}`"
                                            @keydown.enter.prevent="saveApplication"
                                />
                                <div class="invalid-feedback d-block" v-if="priceState === false">
                                    Введіть коректне число
                                </div>
                            </div>
                            
                            <div class="col-md-6">
                                <div class="small text-muted">Нова сума</div>
                                <div class="display-6 fs-3 fw-700">
                                    {{ money(newSumm) }} {{ currencySymbol }}
                                </div>
                                <div class="text-muted small" v-if="position?.currency_id !== 1 && rateNum">
                                    ≈ {{ money(newSumm * rateNum) }} грн за курсом
                                </div>
                            </div>
                        </div>
                    </div>
                    
                    <div class="card-footer d-flex justify-content-end gap-2">
                        <BButton variant="outline-secondary" class="mr-2" @click="close">Скасувати</BButton>
                        <BButton variant="primary" :disabled="!canSend" @click="saveApplication">
                            Зберегти
                        </BButton>
                    </div>
                </div>
            </div>
        </BOverlay>
    </BModal>
</template>

<script>
import {
    BModal,
    BOverlay,
    BButton,
    BFormInput,
    BFormTextarea,
    BFormGroup,
    BFormInvalidFeedback
} from 'bootstrap-vue-next'

export default {
    name: 'edit_application',
    components: { BModal, BOverlay, BButton, BFormTextarea ,BFormGroup, BFormInput, BFormInvalidFeedback},
    
    data() {
        return {
            is_load: false,
            modalShow: false,
            
            positionId : 0,
            app_id : 0,
            position: null,
            
            priceInput: '',
            comment: ''
        }
    },
    
    created() {
        EventBus.$on('app:edit', this.showApplication)
    },
    
    methods: {
     
        showApplication(payload = {}) {
            console.log(payload);
            this.positionId = payload.rec_id;
            if (!this.positionId) return
            
            this.app_id = payload.contragentId;
            
            this.modalShow = true
            this.loadPosition()
        },
        
        async loadPosition() {
            try {
                this.is_load = true
                this.position = null
                this.priceInput = ''
                this.comment = ''
                
                const { data } = await api.get(this.operateUrl)
                
                this.is_load = false
                if (data.status === 'operation_success') {
                    this.position = data.data || null
                    if (this.position) this.priceInput = this.money(this.position.price, false)
                }
                
                
            } catch (e) {
                this.is_load = false
                this.toastErr(e?.response?.data?.message || 'Помилка мережі')
            }
        },
        
        async saveApplication() {
            if (!this.canSend) return
            try {
                this.is_load = true
                
                const payload = {
                    'id' : this.position.id,
                    price: this.parseMoney(this.priceInput),
                    comment: this.comment || ''
                }
                
                
                const { data } = await axios.post('/internal/application/saveAppPrice', payload);
                this.is_load = false
                
                if (data.status === 'operation_success') {
                    this.toastOk('Зміни збережено')
                    // оновимо локально
                    if (this.position) {
                        this.position.price = payload.price
                        this.position.summ = this.round2(payload.price * this.qty)
                    }
                    // повідомимо інших (якщо потрібно)
                    EventBus.$emit('application:updated', {
                        position_id: this.position?.position_id,
                        price: payload.price,
                        summ: this.round2(payload.price * this.qty)
                    })
                    this.close()
                } else {
                    this.toastErr(data.message || 'Не вдалося зберегти')
                }
            } catch (e) {
                this.is_load = false
                this.toastErr(e?.response?.data?.message || 'Помилка збереження')
            }
        },
        
        // форматування грошей для відображення (з пробілами тисяч)
        money(n, withGrouping = true) {
            const x = Number(n || 0)
            if (!withGrouping) return x.toString().replace('.', ',')
            return x.toFixed(2).replace(/(\d)(?=(\d{3})+(\D|$))/g, '$1 ')
        },
        // парсимо введення: «304,470» -> 304.47
        parseMoney(s) {
            if (s === null || s === undefined) return 0
            const cleaned = String(s)
                .replace(/\s+/g, '')
                .replace(/,/g, '.')
                .replace(/[^\d.-]/g, '')
            const val = parseFloat(cleaned)
            return isFinite(val) ? val : 0
        },
        round2(n) {
            return Math.round((Number(n) || 0) * 100) / 100
        },
        
        close() {
            this.modalShow = false
        },
        
        toastOk(msg) {
            EventBus?.$emit?.('show_toast', { type: 'success', err: msg, title: 'OK' })
        },
        toastErr(msg) {
            EventBus?.$emit?.('show_toast', { type: 'danger', err: msg, title: 'Помилка' })
        },
        nf(n) {
            const x = Number(n || 0);
            return x.toFixed(2).replace(/(\d)(?=(\d{3})+(\D|$))/g, '$1 ');
        },
    },
    
    
    computed: {
        
        hasError() {
            // пустое поле — без подсветки (null в :state)
            if (this.priceInput === '' || this.priceInput == null) return false;
            if (!isFinite(this.priceValue) || this.priceValue <= 0) return true;
            if (this.priceValue > this.maxPrice) return true;
            return false;
        },
        
        errorText() {
            if (this.priceInput === '' || this.priceInput == null) return '';
            if (!isFinite(this.priceValue) || this.priceValue <= 0) return 'Вкажіть коректну додатну ціну';
            if (this.priceValue > this.maxPrice) return 'Нова ціна не може бути більшою за подану в заявці';
            return '';
        },
        
        operateUrl() {
            return `/tenders/sales/protocols/inside/applications/${this.app_id}/position/${this.positionId}`;
        },
        
        qty() {
            const q = parseFloat(this.position?.quantity_app ?? 0)
            return isFinite(q) ? q : 0
        },
        
        rateNum() {
            const c = String(this.position?.currency_id || '')
            if (c === '2') return parseFloat(this.position?.usd_exchange_rate || 0)
            if (c === '3') return parseFloat(this.position?.eur_exchange_rate || 0)
            return 1
        },
        
        rate() {
            const r = this.rateNum
            return r ? r.toFixed(6) : '—'
        },
        
        showRate() {
            return String(this.position?.currency_id || '') !== '1'
        },
        
        currencySymbol() {
            const map = { '1': 'грн', '2': 'USD', '3': 'EUR' }
            return map[String(this.position?.currency_id || '')] || (this.position?.name || '')
        },
        
        currencyLabel() {
            const map = { '1': 'грн', '2': 'usd', '3': 'eur' }
            return map[String(this.position?.currency_id || '')] || (this.position?.name || '—')
        },
        
        priceState() {
            if (this.priceInput === '') return null
            return this.parseMoney(this.priceInput) >= 0 ? true : false
        },
        
        newSumm() {
            const p = this.parseMoney(this.priceInput)
            return this.round2(p * this.qty)
        },
        
        placeholderPrice() {
            return this.position ? this.money(this.position.price) : '0.00'
        },
        
        canSend() {
            return this.priceState === true && this.position
        }
    },
}
</script>

<style scoped>
.card-header {
    background: var(--bs-light);
}
.fw-600 { font-weight: 600; }
.fw-700 { font-weight: 700; }
</style>
